
// const BASE_URL:string = 'http://localhost:8080/';
const BASE_URL:string = 'https://sipac.axpe.com/sipac/';

export default BASE_URL;